export default __webpack_public_path__ + "static/media/Web.4d2dd1b6.png";